import ClientsAxios from "../../client-axios";
import { CreateBranchRequest } from "../../dto/request/master/branchMaster.type";
import { ResponseEntity } from "../../dto/response";
import { BranchListResponse } from "../../dto/response/masters/branchMaster.type";

const { API_SERVER } = ClientsAxios;

export const FetchBranchListService = async (payload: {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('branch-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const CreateBranchService = async (payload: CreateBranchRequest, isUpdate: boolean = false) => {
    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const urlType = isUpdate ? 'update-status' : 'store';
        const response = await API_SERVER.post(`branch-master/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteBranchService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('branch-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}